import {useEffect, useState} from "react"
import {createUseStyles} from 'react-jss'
import Card from "../components/Card"
import {useTranslation} from "react-i18next"
import {Link, useParams} from "react-router-dom";
import InfoCard from "../components/InfoCard"
import {Colors} from "../constants/colors"
import {formatTimeString} from "../util/date"
import BackButton from "../components/BackButton"
import { useAppSelector } from "../redux/hooks"
import { Shift } from "../redux/types"
import { hoursToHoursAndMinutesString } from "../util/hourConverter"
import ShiftStatusBadge from "../components/ShiftList/ShiftStatusBadge"
import ShiftTypeBadge from "../components/ShiftList/ShiftTypeBadge"
import PayArticleList from "../components/PayArticle/PayArticleList";

const ShiftDetails = () => {
  const styles = useStyles()
  const {t} = useTranslation(['shifts', 'common']);
  const {shiftId} = useParams()

  const [shiftDetails, setShiftDetails] = useState<Shift>()
  const shiftsOnPage = useAppSelector(state => state.shift.shiftsOnPage)

  useEffect(() => {
    if (shiftsOnPage.length > 0) {
      var shift = shiftsOnPage.find(x => x.id == shiftId)
      if (shift != null) {
        setShiftDetails(shift)
      }
    }
  }, [shiftsOnPage, shiftId])

  return (
    <>
      <BackButton/>
      <Card className={styles.card}>
        <h2>
          {t('shiftDetails', {ns: 'shifts'})}
        </h2>
      </Card>
      <div className={styles.infoCardContainer}>
        <InfoCard title={t('information', {ns: 'common'})} className={styles.infoCard}>
          <div className={styles.row}>
            <div className={styles.label}>{t('type', {ns: 'common'})}</div>
            <div className={styles.badgeContainer}>{shiftDetails && <ShiftTypeBadge shiftType={shiftDetails.type} />} </div>
          </div>
          <div className={styles.row}>
            <div className={styles.label}>{t('id', {ns: 'common'})}</div>
            <div>{shiftDetails?.externalId}</div>
          </div>
          <div className={styles.row}>
            <div className={styles.label}>{t('date', {ns: 'common'})}</div>
            <div>{shiftDetails?.date}</div>
          </div>
          <div className={styles.row}>
            <div className={styles.label}>{t('workingHours', {ns: 'shifts'})}</div>
            <div>{shiftDetails?.startTime && `${formatTimeString(shiftDetails.startTime ?? undefined)} - ${formatTimeString(shiftDetails.endTime ?? undefined)}`}</div>
          </div>
          <div className={styles.row}>
            <div className={styles.label}>{t('paidWorkingHours', {ns: 'shifts'})}</div>
            <div>{shiftDetails && hoursToHoursAndMinutesString(shiftDetails.hours)}</div>
          </div>
          <div className={styles.row}>
            <div className={styles.label}>{t('grossWages', {ns: 'shifts'})}</div>
            <div>{shiftDetails?.grossValue.amount.toLocaleString('sv-SE', {minimumFractionDigits: 2})} {shiftDetails?.grossValue.currencyCode.toUpperCase()}</div>
          </div>
          <div className={styles.row}>
            <div className={styles.label}>{t('status', {ns: 'common'})}</div>
            <div className={styles.badgeContainer}>{shiftDetails && <ShiftStatusBadge shiftStatus={shiftDetails.status} />} </div>
          </div>
          <div className={styles.row}>
            <div className={styles.label}>{t('employee', {ns: 'common'})}</div>
            <div>
              <Link to={`/employees/${shiftDetails?.employee.id}`}>
                  {shiftDetails?.employee.name}
              </Link>
            </div>
          </div>
        </InfoCard>
        <InfoCard title={t('payArticles', {ns: 'common'})} className={styles.articleCard}>
          {shiftDetails?.payArticles && <PayArticleList payArticles={shiftDetails?.payArticles} />}
        </InfoCard>
      </div>
    </>
  )
}

export default ShiftDetails

const useStyles = createUseStyles({
  card: {
    marginBottom: 20
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    gap: 10,
    marginBottom: 20,
  },
  infoCardContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    columnGap: 20
  },
  infoCard: {
    flex: 1
  },
  articleCard: {
    flex: 3
  },
  row: {
    flex: 1,
    marginBottom: 10,
  },
  badgeContainer: {
    flexShrink: 0,
    flexGrow: 1,
    display: 'flex',
    width: 120,
    flexWrap: 'wrap',
  },
  label: {
    display: 'flex',
    flexDirection: 'row',
    columnGap: 10,
    textTransform: 'uppercase',
    fontSize: 13,
    color: Colors.gray3
  }
})
